export var AlignMap;
(function (AlignMap) {
    AlignMap["baseline"] = "baseline";
    AlignMap["center"] = "center";
    AlignMap["end"] = "flex-end";
    AlignMap["start"] = "flex-start";
    AlignMap["stretch"] = "stretch";
})(AlignMap || (AlignMap = {}));
export const align = ['baseline', 'center', 'end', 'start', 'stretch'];
export var JustifyMap;
(function (JustifyMap) {
    JustifyMap["around"] = "space-around";
    JustifyMap["between"] = "space-between";
    JustifyMap["center"] = "center";
    JustifyMap["end"] = "flex-end";
    JustifyMap["start"] = "flex-start";
})(JustifyMap || (JustifyMap = {}));
export const justify = [
    'around',
    'between',
    'center',
    'end',
    'start',
];
export var DirectionMap;
(function (DirectionMap) {
    DirectionMap["row"] = "row";
    DirectionMap["column"] = "column";
})(DirectionMap || (DirectionMap = {}));
export const direction = ['row', 'column'];
export var WrapMap;
(function (WrapMap) {
    WrapMap["wrap"] = "wrap";
    WrapMap["nowrap"] = "nowrap";
})(WrapMap || (WrapMap = {}));
export const wrap = ['wrap', 'nowrap'];
//# sourceMappingURL=Layout.types.mjs.mjs.map